import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, Network, ArrowRight } from 'lucide-react';

const SolutionsSection = () => {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5 leading-[1.1] tracking-tight">
            The all-in-one platform for<br />
            <span className="text-blue-600">practices of all sizes</span>
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Whether you're a solo practice or a multi-location DSO, Asha scales with you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {[
            {
              icon: Building2,
              iconColor: 'text-blue-600',
              title: 'Dental Practices',
              description: 'Asha automates your entire front and back office, freeing your staff to focus on patients. Reduce errors, accelerate revenue cycle, and improve efficiency seamlessly.',
              link: '/solutions/private-practices',
              linkColor: 'text-blue-600 hover:text-blue-700',
              image: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=800&auto=format&fit=crop',
            },
            {
              icon: Network,
              iconColor: 'text-indigo-600',
              title: 'DSOs',
              description: 'Asha unifies operations across your entire network. Standardize workflows, reduce inconsistencies, and boost revenue with enterprise-grade AI infrastructure.',
              link: '/solutions/dsos',
              linkColor: 'text-indigo-600 hover:text-indigo-700',
              image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&auto=format&fit=crop',
            }
          ].map((solution, idx) => {
            const Icon = solution.icon;
            return (
              <div key={idx} className="group relative bg-gray-50 rounded-3xl overflow-hidden border border-gray-100 hover:shadow-xl hover:shadow-gray-200/50 transition-all duration-500 hover:-translate-y-1">
                <div className="p-10 relative z-10">
                  <div className={`w-12 h-12 bg-white rounded-2xl flex items-center justify-center mb-6 shadow-sm ${solution.iconColor} border border-gray-100 group-hover:scale-110 transition-transform duration-300`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{solution.title}</h3>
                  <p className="text-base text-gray-500 leading-relaxed mb-8 max-w-md">{solution.description}</p>
                  <Link to={solution.link} className={`font-semibold text-base ${solution.linkColor} transition-colors flex items-center space-x-2 group-hover:translate-x-1 duration-300`}>
                    <span>Learn more</span>
                    <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
                <div className="relative h-64 overflow-hidden mt-2">
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-50 via-transparent to-transparent z-10" />
                  <img src={solution.image} alt={solution.title} className="w-full h-full object-cover group-hover:scale-105 transition-all duration-700" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
